import React from 'react';

const TestimonialContainer = ({ children }) => (
  <div className="testimonial-container">
    {children}
  </div>
);

export default TestimonialContainer;